<template>
  <div
    id="login"
    class="modal fade black-modal"
    role="dialog"
    data-backdrop="true"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div
          class="sticky-top container-fluid"
          data-padding-right=""
          data-margin-right=""
          style=""
        >
          <div
            class="align-items-center justify-content-center py-0 modalTopClose row"
          >
            <div class="col-2">
              <button data-dismiss="modal" class="button-close mt-1">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="arrow-left"
                  class="svg-inline--fa fa-arrow-left p-0 text-white"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  style="font-size: 20px;"
                >
                  <path
                    fill="currentColor"
                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="d-flex justify-content-center col-8">
              <a data-animatable="fadeInUp" data-delay="500" href="/">
                <div class="logo-title pt-1 img-fluid my-2">
                  <img
                    alt="ZEAGAME แทงบอลออนไลน์ คาสิโนออนไลน์"
                    loading="eager"
                    width="190"
                    height="48"
                    decoding="async"
                    data-nimg="1"
                    class="animated fadeInUp img-fluid"
                    src="/static/img/logo/logo.png"
                    style="color: transparent;"
                  />
                </div>
              </a>
            </div>
            <div class="text-right col-2">
              <button data-dismiss="modal" class="button-close">
                <img
                  src="/static/img/landing/closeIcon.png"
                  width="40"
                  height="40"
                  alt="ปิด"
                  class=""
                />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <div class="container">
            <h5>ลงชื่อเข้าสู่ระบบ</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="py-4 container">
            <form novalidate="" class="">
              <div class="row">
                <div class="col-12">
                  <label style="padding-bottom: 5px;"
                    >ชื่อผู้ใช้ (Username)</label
                  ><input
                    placeholder="เบอร์โทรศัพท์"
                    v-model="phoneNumber"
                    name="username"
                    minlength="6"
                    maxlength="20"
                    required=""
                    type="tel"
                    class="form-control"
                    value=""
                  />
                </div>

                <div class="col-12">
                  <label style="padding-bottom: 5px;">รหัสผ่าน (Password)</label
                  ><input
                    aria-label="รหัสผ่าน"
                    v-model="password"
                    name="password"
                    placeholder="รหัสผ่าน"
                    minlength="6"
                    maxlength="20"
                    required=""
                    type="password"
                    class="form-control"
                    value=""
                  />
                </div>

                <div class="text-right col-12">
                  <a
                    class="sa-text-primary"
                    v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank"
                    style="float: right; font-size: 1rem;"
                    >ลืมรหัสผ่าน?</a
                  >
                </div>
              </div>
              <div class="pt-3 row">
                <div class="col-12">
                  <button type="button" @click="Login()" class="submit-login">
                    <span></span>เข้าสู่ระบบ
                  </button>
                </div>
                <div
                  class="modalSeparate d-flex align-items-center justify-content-center col-12"
                >
                  <span></span>หรือ<span></span>
                </div>
                <div class="col-12">
                  <button
                    data-toggle="modal"
                    data-target="#register"
                    data-dismiss="modal"
                    type="button"
                    class="submit-register"
                  >
                    <span></span>สมัครสมาชิก
                  </button>
                </div>
                <div
                  class="modalSeparate d-flex align-items-center justify-content-center col-12"
                >
                  <span></span>หรือ<span></span>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
 
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LoginForm",
  data() {
    return {
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    async Register() {
      $("#login").modal("hide");
      $("#regModal").modal("show");
    },
  },
  mounted() {
    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }
    $(".overlaymodal").on("click", function() {
      $("#login").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/LoginForm.vue